'<router-outlet></router-outlet>'
